<template>
    <div class="straw-box">
        <input type="color" id="strawInput"/>
        <img src="@/assets/img/straw.png" class="imgs">
    </div>
</template>

<script>
    export default {
        name: "Color",
        data(){
            return {
                color: ""
            }
        },
        mounted() {
            let _this = this
            const theInput = document.getElementById("strawInput")
            theInput.addEventListener("input", function() {
                _this.color = _this.conversion(theInput.value)
            }, false)
        },
        watch: {
            color:{
                handler(newv){
                    if(newv) this.$emit('change',newv)
                }
            }
        },
        methods: {
            //16進制轉爲rgb
            conversion(value) {
                // 16進制顔色值的正則
                let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
                // 把顔色值變成小寫
                let color = value.toLowerCase();
                if (reg.test(color)) {
                    // 如果只有三位的值，需變成六位，如：#fff => #ffffff
                    if (color.length === 4) {
                        let colorNew = "#";
                        for (let i = 1; i < 4; i += 1) {
                            colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
                        }
                        color = colorNew;
                    }
                    // 處理六位的颜色值，轉爲RGB
                    let colorChange = [];
                    for (let j = 1; j < 7; j += 2) {
                        colorChange.push(parseInt("0x" + color.slice(j, j + 2)));
                    }
                    return "RGB(" + colorChange.join(",") + ")";
                }
                else {
                    return color;
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    .straw-box{
        width: 24px;
        height: 24px;
        border-radius: 3px;
        background-color: rgba(255,255,255,.2);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        overflow: hidden;
        #strawInput{
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 100;
            cursor: pointer;
        }
        .imgs{
            width: 12px;
            opacity: .8;
        }
    }
</style>